// src/GithubIcon.tsx
import { jsx } from "react/jsx-runtime";
var GithubIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "21",
    height: "21",
    viewBox: "0 0 21 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M10.7037 0.0253909C5.67367 0.0247448 1.38582 3.67267 0.580479 8.63778C-0.224861 13.6029 2.69011 18.4191 7.46243 20.0084C7.97643 20.1009 8.16044 19.7853 8.16044 19.5139C8.16044 19.2703 8.15221 18.6247 8.14913 17.7664C5.29647 18.3832 4.69407 16.3909 4.69407 16.3909C4.50627 15.771 4.10254 15.2389 3.55609 14.8911C2.6309 14.2548 3.62702 14.2692 3.62702 14.2692C4.28563 14.3595 4.86528 14.7497 5.19675 15.3259C5.47732 15.8361 5.95002 16.213 6.5098 16.3731C7.06959 16.5331 7.6701 16.4629 8.17791 16.1781C8.22563 15.658 8.45705 15.1718 8.83068 14.8068C6.55472 14.5488 4.16157 13.6688 4.16157 9.73883C4.14894 8.72235 4.5264 7.7397 5.21628 6.99308C4.90414 6.1083 4.9409 5.13782 5.31908 4.2792C5.31908 4.2792 6.17951 4.00267 8.13782 5.32877C9.81739 4.86824 11.59 4.86824 13.2695 5.32877C15.2289 4.00164 16.0883 4.2792 16.0883 4.2792C16.4682 5.13742 16.505 6.10857 16.1911 6.99308C16.8835 7.73963 17.2606 8.72486 17.2437 9.74294C17.2437 13.6832 14.8485 14.5488 12.5643 14.8027C13.0571 15.3065 13.3098 15.9976 13.2582 16.7003C13.2582 18.0717 13.2459 19.1778 13.2459 19.5139C13.2459 19.7884 13.4289 20.1071 13.9521 20.0063C18.7224 18.4144 21.6343 13.5979 20.8273 8.63407C20.0203 3.67027 15.7326 0.0242401 10.7037 0.0253909Z" })
  }
);
var GithubIcon_default = GithubIcon;

export {
  GithubIcon_default
};
